export default __webpack_public_path__ + "static/media/camaronDeRio.8f2317d4.jpg";